import { useContext } from "react";
import Head from "next/head";

import { Context } from "../../../context";
import Layout from "../../../components/Layout";
import BannerAd from "../../../components/BannerAd";
import {
  pageStyle, mediumFont, maxSection1, maxSection2, breakpoint0
} from "../../../utils/styles";
import Image from "../../../components/Image";
import GoogleAd from "../../../components/GoogleAd";

const GameCategories = () => {
  const { menu, theme } = useContext(Context);
  const { categories } = menu;

  return (
    <Layout>
      <Head>
        <title>Game Categories - AppCheeta</title>

        <script
          dangerouslySetInnerHTML={{
            __html: `
              window.pg = window.pg || {};
              pg.disabledUnits = pg.disabledUnits || [];
              pg.disabledUnits.push('/23081961,22672082578/appcheeta_desk_leaderboard_lazy', '/23081961,22672082578/appcheeta_desk_sidebar1', '/23081961,22672082578/appcheeta_desk_sidebar2', '/23081961,22672082578/appcheeta_mob_leaderboard', '/23081961,22672082578/appcheeta_mob_leaderboard_lazy');
            `,
          }}
        />
      </Head>
      <div className="page-content">
        <style jsx>{pageStyle}</style>
        <style jsx>
          {`
            .section {
              margin-top: 2rem;
              margin-bottom: 2.5rem;
            }
            .section-content {
              margin-bottom: 2rem;
            }
            .subtitle {
              font-size: ${mediumFont};
              font-weight: bold;
              margin-bottom: 1.5rem;
            }
            .categories {
              display: grid;
              grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
              padding: 0;
            }
            .category {
              padding: 0 6px;
              margin-bottom: 2rem;
              text-decoration: none;
            }
            .title {
              text-align: center;
              color: ${theme.primaryTextColor};
              font-size: 1rem;
              margin-top: 0.5rem;
            }
            @media screen and (max-width: ${maxSection2}px) {
              .categories {
                grid-template-columns: 1fr 1fr 1fr 1fr;
              }
            }
            @media screen and (max-width: ${maxSection1}px) {
              .categories {
                grid-template-columns: 1fr 1fr 1fr;
              }
            }
            @media screen and (max-width: ${breakpoint0}px) {
              .categories {
                grid-template-columns: 1fr 1fr;
              }
            }
            @media screen and (max-width: 480px) {
              .categories {
                grid-template-columns: 1fr;
              }
            }
          `}
        </style>
        <BannerAd />
        <div className="section">
          <h2 className="subtitle">Game Categories</h2>
          <div className="section-content">
            <div className="categories">
              {categories.map((category) => (
                <a
                  className="category"
                  key={category.slug}
                  href={`/game/category/${category.slug}`}
                >
                  <Image
                    path={category.image}
                    width={350}
                    height={200}
                    type="category"
                  />
                  <h3 className="title">{category.name}</h3>
                </a>
              ))}
            </div>
          </div>
        </div>

        <GoogleAd section="leaderboard" />
      </div>
    </Layout>
  );
};

GameCategories.getInitialProps = async () => {
  const analytics = {
    content_group1: "Game Categories",
  };
  return { analytics };
};

export default GameCategories;
